import { contactPathCreator } from '../../../../../routes/employer/paths/contact.paths';
import { BreadcrumbLink } from '../../../../shared/components/breadcrumbs/BreadcrumbLink';

export const ContactListBreadcrumb = (): React.ReactElement<any, any> | null => (
    <BreadcrumbLink to={contactPathCreator.list({ isActive: true })}>Contacts</BreadcrumbLink>
);
